import React, { useState } from 'react';
import { pullApns } from '/imports/api/devtools';
import { toastOnError } from '/imports/ui/utils';
import { DevToolSection } from '/imports/ui/DevToolSection';

/** Dev tool section that pulls SANDAG parcel (APN) data for the San Diego region. */
export const DevToolPullApns = () => {
  const [loading, setLoading] = useState(false);
  const run = toastOnError(async () => {
    setLoading(true);
    try {
      await pullApns.call();
    }
    finally {
      setLoading(false);
    }
  });
  return (
    <DevToolSection
      title="Pull APNs"
      description="Pull parcel data from SANDAG (San Diego region)"
      onRun={() => run()}
      loading={loading}
    />
  );
};
